import { NavTabsCode } from './codeHighlights/NavTabsCode';

const NavTabs = () => {
  return (
    <>
      <ul className="nav nav-tabs mt-5" id="myTab" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            className="nav-link active"
            id="home-tab"
            data-bs-toggle="tab"
            data-bs-target="#home-tab-pane"
            type="button"
            role="tab"
            aria-controls="home-tab-pane"
            aria-selected="true"
          >
            Tab I
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id="profile-tab"
            data-bs-toggle="tab"
            data-bs-target="#profile-tab-pane"
            type="button"
            role="tab"
            aria-controls="profile-tab-pane"
            aria-selected="false"
          >
            Tab II
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id="contact-tab"
            data-bs-toggle="tab"
            data-bs-target="#contact-tab-pane"
            type="button"
            role="tab"
            aria-controls="contact-tab-pane"
            aria-selected="false"
          >
            Tab III
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id="disabled-tab"
            data-bs-toggle="tab"
            data-bs-target="#disabled-tab-pane"
            type="button"
            role="tab"
            aria-controls="disabled-tab-pane"
            aria-selected="false"
            disabled
          >
            Disabled
          </button>
        </li>
      </ul>
      <div className="tab-content" id="myTabContent">
        <div
          className="tab-pane fade show active"
          id="home-tab-pane"
          role="tabpanel"
          aria-labelledby="home-tab"
          tabIndex={0}
        >
          <h2>Tab-Content I</h2>
          <p>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illum
            perferendis necessitatibus doloremque tempore earum. Eos eum vel
            culpa magni eveniet, numquam velit commodi! Facilis sint dolores,
            quis accusamus minima incidunt maiores ab unde dicta placeat cum
            recusandae veritatis odio nesciunt saepe facere, sed temporibus
            labore natus, corrupti illo! Iure, doloremque officiis doloribus
            eligendi ad amet molestias quas a ipsum beatae illo dolores quod
            excepturi modi cupiditate eius. Repellat, eos. Nihil, iure
            quibusdam. Sint id repudiandae nemo neque autem aspernatur tenetur,
            similique repellat nihil sunt totam, labore exercitationem quia ut
            sed! Non in ad quod sed culpa. Blanditiis nostrum culpa cumque!
          </p>
        </div>
        <div
          className="tab-pane fade"
          id="profile-tab-pane"
          role="tabpanel"
          aria-labelledby="profile-tab"
          tabIndex={0}
        >
          <h2>Tab-Content II</h2>
          <p>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illum
            perferendis necessitatibus doloremque tempore earum. Eos eum vel
            culpa magni eveniet, numquam velit commodi! Facilis sint dolores,
            quis accusamus minima incidunt maiores ab unde dicta placeat cum
            recusandae veritatis odio nesciunt saepe facere, sed temporibus
            labore natus, corrupti illo! Iure, doloremque officiis doloribus
            eligendi ad amet molestias quas a ipsum beatae illo dolores quod
            excepturi modi cupiditate eius. Repellat, eos. Nihil, iure
            quibusdam. Sint id repudiandae nemo neque autem aspernatur tenetur,
            similique repellat nihil sunt totam, labore exercitationem quia ut
            sed! Non in ad quod sed culpa. Blanditiis nostrum culpa cumque!
          </p>
        </div>
        <div
          className="tab-pane fade"
          id="contact-tab-pane"
          role="tabpanel"
          aria-labelledby="contact-tab"
          tabIndex={0}
        >
          <h2>Tab-Content III</h2>
          <p>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illum
            perferendis necessitatibus doloremque tempore earum. Eos eum vel
            culpa magni eveniet, numquam velit commodi! Facilis sint dolores,
            quis accusamus minima incidunt maiores ab unde dicta placeat cum
            recusandae veritatis odio nesciunt saepe facere, sed temporibus
            labore natus, corrupti illo! Iure, doloremque officiis doloribus
            eligendi ad amet molestias quas a ipsum beatae illo dolores quod
            excepturi modi cupiditate eius. Repellat, eos. Nihil, iure
            quibusdam. Sint id repudiandae nemo neque autem aspernatur tenetur,
            similique repellat nihil sunt totam, labore exercitationem quia ut
            sed! Non in ad quod sed culpa. Blanditiis nostrum culpa cumque!
          </p>
        </div>
        <div
          className="tab-pane fade"
          id="disabled-tab-pane"
          role="tabpanel"
          aria-labelledby="disabled-tab"
          tabIndex={0}
        >
          ...
        </div>
      </div>
      <div className="mt-5">
        <h2>Navigation-Tab Code</h2>
        <NavTabsCode />
      </div>
    </>
  );
};

export default NavTabs;
